"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //      

// Copyright (c) 2020 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Request functions
 */
var Request = function () {
	function Request() {
		_classCallCheck(this, Request);
	}

	_createClass(Request, null, [{
		key: "processResponse",


		/**
   * Processes a request response checking if the results are ok
   * and resolves or rejects accordingly
   *
   * @param {Object} response
   */
		value: function processResponse(response, resolve, reject) {

			if (response.status === 200) {
				var data = response.data;

				if (data.ok === false) {

					reject(data.message);
				} else {

					resolve(data);
				}
			} else {

				reject(response.status);
			}
		}
	}, {
		key: "processError",
		value: function processError(err, reject) {

			reject(err.message);
		}

		/**
   * Does a get request
   *
   * @param {string} url The URL where the get request should be made
   */

	}, {
		key: "get",
		value: function get(url) {

			return new Promise(function (resolve, reject) {

				_axios2.default.get(url).then(function (response) {
					return Request.processResponse(response, resolve, reject);
				}).catch(function (err) {
					return Request.processError(err, reject);
				});
			});
		}

		/**
   * Does a get request
   *
   * @param {string} url The URL where the get request should be made
   */

	}, {
		key: "delete",
		value: function _delete(url) {

			return new Promise(function (resolve, reject) {

				_axios2.default.delete(url).then(function (response) {
					return Request.processResponse(response, resolve, reject);
				}).catch(function (err) {
					return Request.processError(err, reject);
				});
			});
		}

		/**
   * Does a post request
   *
   * @param {string} url The URL where the post should be made
   * @param {any} data The data to send in the post request
   */

	}, {
		key: "post",
		value: function post(url, data) {

			return new Promise(function (resolve, reject) {

				_axios2.default.post(url, data).then(function (response) {
					return Request.processResponse(response, resolve, reject);
				}).catch(function (err) {
					return Request.processError(err, reject);
				});
			});
		}

		/**
   * Does a post request
   *
   * @param {string} url The URL where the post should be made
   * @param {any} data The data to send in the post request
   */

	}, {
		key: "put",
		value: function put(url, data) {

			return new Promise(function (resolve, reject) {

				_axios2.default.put(url, data).then(function (response) {
					return Request.processResponse(response, resolve, reject);
				}).catch(function (err) {
					return Request.processError(err, reject);
				});
			});
		}
	}]);

	return Request;
}();

module.exports = Request;
